import { createFileRoute } from '@tanstack/react-router';

import { adsTxtAppsRouteSearchSchema } from '../features/supply/adsTxt/adsTxtAppsRouteSearch';
import { AdsTxtAppsTable } from '../features/supply/adsTxt/components/AdsTxtAppsTable';

export const Route = createFileRoute('/supply/ads-txt/apps')({
  validateSearch: adsTxtAppsRouteSearchSchema,
  component: AdsTxtAppsTable,
});
